import React from 'react';

export const Maintenance = () => {
	return (
		<svg width="301" height="161" viewBox="0 0 301 161" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_12238_171819)">
				<rect x="60.4766" y="58.458" width="4.77344" height="96.2441" fill="#D9D9D9" />
				<rect x="169.852" y="58.458" width="4.77344" height="96.2441" fill="#D9D9D9" />
				<path d="M207.899 57.5298H212.672L183.367 139.93H178.594L207.899 57.5298Z" fill="#D9D9D9" />
				<path d="M60.7031 57.3198V154.702H65.2535V57.3198" stroke="#A6A6A6" strokeWidth="2" />
				<path d="M169.852 57.3198V154.702H174.402V57.3198" stroke="#A6A6A6" strokeWidth="2" />
				<circle cx="62.9761" cy="54.4966" r="4.4214" fill="#EBEBEB" stroke="#A6A6A6" strokeWidth="2" />
				<circle cx="172.132" cy="54.4966" r="4.4214" fill="#EBEBEB" stroke="#A6A6A6" strokeWidth="2" />
				<rect
					x="65.5781"
					y="73.0005"
					width="104.182"
					height="37.6114"
					fill="#ffcc00"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<path
					d="M68.2728 110.612L83.2856 73.0005H98.1445L83.1317 110.612H68.2728Z"
					fill="white"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<path
					d="M91.679 110.612L106.692 73.0005H121.551L106.538 110.612H91.679Z"
					fill="white"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<path
					d="M115.093 110.612L130.106 73.0005H144.965L129.952 110.612H115.093Z"
					fill="white"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<path
					d="M138.499 110.612L153.512 73.0005H168.371L153.358 110.612H138.499Z"
					fill="white"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<line x1="46.1562" y1="155.032" x2="188.447" y2="155.032" stroke="#ABABAB" strokeWidth="2" />
				<line x1="174.406" y1="140.973" x2="229.463" y2="140.973" stroke="#ABABAB" strokeWidth="2" />
				<line x1="197.266" y1="155.032" x2="209.423" y2="155.032" stroke="#ABABAB" strokeWidth="2" />
				<line x1="236.352" y1="140.973" x2="249.807" y2="140.973" stroke="#ABABAB" strokeWidth="2" />
				<line x1="157.305" y1="140.973" x2="170.76" y2="140.973" stroke="#ABABAB" strokeWidth="2" />
				<path
					d="M208.469 53.8962L178.594 140.328L183.475 140.328L213.229 55.5415"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<rect
					x="189.97"
					y="61.889"
					width="34.776"
					height="25.4304"
					rx="3"
					transform="rotate(19.0679 189.97 61.889)"
					fill="#F4F4F4"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<circle
					cx="218.188"
					cy="33.4318"
					r="28.1184"
					transform="rotate(19.0679 218.188 33.4318)"
					fill="#ffcc00"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<circle
					cx="218.192"
					cy="33.4316"
					r="18.5566"
					transform="rotate(19.0679 218.192 33.4316)"
					fill="white"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<path
					d="M192.029 79.4827L193.087 78.8622C193.399 79.5987 193.967 80.1403 194.81 80.4319C195.755 80.7585 196.549 80.3918 196.796 79.676C197.07 78.8831 196.664 78.1634 195.742 77.8446C195.101 77.623 194.504 77.6385 193.88 77.9157L193.038 77.3288L194.458 73.2211L199.372 74.9199L198.98 76.0542L195.381 74.8102L194.646 76.9356C195.128 76.7076 195.846 76.6351 196.565 76.8839C197.825 77.3193 198.66 78.582 198.142 80.0797C197.613 81.6104 196.101 82.1604 194.425 81.5811C193.132 81.134 192.392 80.3974 192.029 79.4827Z"
					fill="#A3A3A3"
				/>
				<path
					d="M199.524 79.0903C200.164 77.2402 201.733 75.613 203.836 76.34C205.939 77.0669 206.169 79.3162 205.529 81.1663C204.89 83.0164 203.316 84.6546 201.213 83.9277C199.11 83.2007 198.885 80.9405 199.524 79.0903ZM204.191 80.7037C204.675 79.3051 204.666 77.909 203.44 77.4853C202.215 77.0615 201.346 78.1543 200.862 79.5529C200.379 80.9516 200.383 82.3586 201.609 82.7823C202.835 83.2061 203.708 82.1023 204.191 80.7037Z"
					fill="#A3A3A3"
				/>
				<path
					d="M205.36 84.0298L206.362 83.4267C206.655 84.1445 207.336 84.7619 208.134 85.0379C209.124 85.38 209.849 85.1378 210.086 84.455C210.337 83.7282 209.847 83.2138 208.779 82.8445C208.464 82.7356 208.026 82.584 207.909 82.5561L208.309 81.3998C208.44 81.4575 208.879 81.6091 209.171 81.7102C210.048 82.0134 210.815 81.9454 211.047 81.2737C211.283 80.5909 210.73 80.0052 209.887 79.7136C209.122 79.4493 208.393 79.5179 207.671 79.8599L207.274 78.8228C208.076 78.3603 209.158 78.1796 210.406 78.6111C212.026 79.1709 212.857 80.2969 212.431 81.5303C212.092 82.5104 211.04 82.7876 210.218 82.6515C210.926 82.9703 211.736 83.9038 211.344 85.0381C210.914 86.2825 209.515 86.7975 207.783 86.1988C206.445 85.7362 205.638 84.8655 205.36 84.0298Z"
					fill="#A3A3A3"
				/>
			</g>
			<defs>
				<clipPath id="clip0_12238_171819">
					<rect width="300" height="160" fill="white" transform="translate(0.6875 0.5)" />
				</clipPath>
			</defs>
		</svg>
	);
};
